/* BPSC ENDPOINTS*/
export const OTPS = "/oas/api/v1/otps";
export const VERIFYOTP = "/oas/api/v1/verifyotps";
export const LOOKUP_OPTION = "/oas/api/v1/lookupoption";
export const SESSION_HEARTBEAT = "/oas/api/v1/sessionheartbeat";
export const SESSION_ADMIN_HEARTBEAT = "/oas/api/v1/admin/sessionheartbeat";
export const CONFIGURATION = "/oas/api/v1/configuration";

export const SECURITY_QUESTIONS = "/oas/api/v1/securityquestion";
export const REGISTRATION = "/oas/api/v1/register";
export const LOGIN = "/oas/api/v1/authenticate";
export const ADDRESS_INFORMATION = "/oas/api/v1/addressinformationdraft";
export const EXPERIENCE_INFORMATION = "/oas/api/v1/experienceinformationdraft";
export const QUALIFICATION_INFORMATION =
  "/oas/api/v1/qualificationinformationdraft";
export const OTHER_INFORMATION = "/oas/api/v1/otherinformationdraft";
export const PERSONALINFORMATION = "/oas/api/v1/createpersonalinformation";
export const LOOKUP_OPTIONS = "/oas/api/v1/lookupoption";
export const STATES = "/oas/api/v1/state";
export const DISTRICTS = "/oas/api/v1/district";
export const TALUKAS = "/oas/api/v1/taluka";
export const VILLAGES = "/oas/api/v1/village";
export const QUALIFICATION_TYPES = "/oas/api/v1/qualificationtype";
export const QUALIFICATION_NAME = "/oas/api/v1/qualificationname";
export const SUBJECTS = "/oas/api/v1/subject";
export const UNIVERSITIES = "/oas/api/v1/university";
export const PROFILE_CREATION = "/oas/api/v1/personalinformationdraft";
export const PHOTO_URL = "/oas/api/v1/photosignaturedraft";
export const GET_DISPLAYABLE_QUALIFICATION_LIST =
  "/oas/api/v1/getdisplayablequalificationlist";
export const FORGETPASSWORD = "/oas/api/v1/forgotpassword";
export const RESETPASSWORD = "/oas/api/v1/resetpassword";
export const ADVERTISEMENT = "/oas/api/v1/advertisements";
export const CHECK_ELIGIBILITY = "/oas/api/v1/checkeligibility";
export const UPDATEFEESPAIDAPPLICATION =
  "/oas/api/v1/updatefeespaidapplication";
export const GET_DOCUMENT_LIST = "/oas/api/v1/advertisementreqdocuments";
export const DOWNLOAD_DOCUMENT = "/oas/api/v1/downloadrequireddocuments";
export const UPLOAD_DOCUMENT = "/oas/api/v1/uploadrequireddocuments";
export const ADVERTISEMENT_PDF = "/oas/api/v1/downloadpdfadvertisement/";
export const APPLICATIONS = "/oas/api/v1/applications";
export const POST_PREFERENCE_DETAILS = "/oas/api/v1/preferences";
export const UPDATED_POST_PREFERENCE_DETAILS = "/oas/api/v1/preferences";
export const OPT_OUT_FROM_APPLICATION = "/oas/api/v1/optout";
export const HAS_PENDING_TRANSACTIONS =
  "/oas/api/v1/payment/haspendingtransactions";
export const RECONCILE_NOW = "/oas/api/v1/payment/reconcilenow";
export const PROFILE_INFO_DISPLAY = "/oas/api/v1/profilecreationdraft";
export const API_REPO_VERSION = "/oas/api/v1/version";
export const API_APPLICATION_RECEIPT = "/oas/api/v1/receipts/";
export const API_CHALLAN_PAYMENT_RECEIPT = "/oas/api/v1/selectchallanpayment/";
export const API_CHALLAN_SLIP = "/oas/api/v1/downloadchallanslip/";
export const CHANGE_PASSWORD = "/oas/api/v1/changepassword";
export const OTP_FOR_EMAIIL_MOBILE = "/oas/api/v1/otpsforemailmobile";
export const UPDATE_PROFILE = "/oas/api/v1/updateprofile";
export const FORGOT_LOGIN = "/oas/api/v1/forgotlogin";
export const PROFILE_SUMMARY = "/oas/api/v1/profilesummary";
export const LOGOUT = "/oas/api/v1/logout";
export const ADMIN_LOGOUT = "/oas/api/v1/admin/logout";
export const CANCEL_APPLICATION = "/oas/api/v1/cancelapplications";
export const MERGED_PROFILE_INFO_DISPLAY =
  "/oas/api/v1/profilecreationmergeddraft";
export const PAYNOW = "/oas/api/v1/paynow/";
export const PAYMENTDETAILS = "/oas/api/v1/paymentdetails/";
export const SBIEPAY = "/oas/api/v1/paynow/sbiepay/";
export const BILLDESK = "/oas/api/v1/payment/billdesk/";
export const VERIFY_CANDIDATES = "/oas/api/v1/verifyresetemailmobile";
export const UPDATEEMAILMOBILE = "/oas/api/v1/updateresetemailmobile";
export const EXAM_CENTER_LIST = "/oas/api/v1/examcentersbyadvtid";
export const QUIKWALLET_EPAY = "/oas/api/v1/paynow/quickwallet/";
export const USERCORRESPONDENCE =
  "/oas/api/v1/correspondence/usercorrespondence";
export const DOWNLOADCORRESPONDENCEDOC =
  "/oas/api/v1/correspondence/downloadcorrespondencedoc";
export const USER_APPLICATION_STAGES =
  "/oas/api/v1/userapplicationstages/userdata";
export const VERIFY_SECURITY_ANSWER = "/oas/api/v1/verifysecurityanswers";
export const UPDATE_SECURITY_ANSWER = "/oas/api/v1/updatesecurityanswer";
export const RECHECK_ELIGIBILITY = "/oas/api/v1/recheckeligibility";
export const MODULE_CHECK = "/oas/api/v1/module";
export const LOG_OUT_USER_OTP = "/oas/api/v1/logoutother";
export const LOG_OUT_OTP_VERIFICATION = "/oas/api/v1/validateotpforlogout";
export const GETMARKSHEET = "/oas/api/v1/marksheet";
export const DOWNLOADMARKSHEET = "/oas/api/v1/downloadmarksheet";
export const GET_ADVERTISEMENT_POST_SUBJECTS =
  "/oas/api/v1/retotaling/getsubjects";
export const GET_RETOTALING_REQUESTS_BY_APP_ID =
  "/oas/api/v1/retotaling/requests/application";
export const MAKE_RETOTALING_REQUEST = "/oas/api/v1/retotaling/requests";
export const QUIKWALLET_EPAY_RETOTALING =
  "/oas/api/v1/retotaling/paynow/quickwallet/";
export const PAYNOW_RETOTALING = "/oas/api/v1/retotaling/paynow/ccavenue/";
export const SBIEPAY_RETOTALING = "/oas/api/v1/retotaling/paynow/sbiepay/";
export const BILLDESK_RETOTALING = "/oas/api/v1/retotaling/paynow/billdesk/";
export const EASEBUZZEPAY_RETOTALING =
  "/oas/api/v1/retotaling/paynow/easebuzz/";
export const EASEBUZZ_EPAY = "/oas/api/v1/easebuzz/";
export const EASEBUZZ_CALLBACK = "/oas/api/v1/payment/easebuzz/";
export const GET_ADDITIONAL_RES_ENV =
  "/oas/api/v1/profilecreation/getadditionalreservationrequired";
export const GETDEPARTMENTS = "/oas/api/v1/admin/getdepartments";
export const GETALLDEPARTMENTS =
  "/oas/api/v1/admin/getallappointingauthorities";
export const GETADMITCARD = "/oas/api/v1/admin/timetable/admitcard";
export const GETOBJECTIONREQUEST = "/oas/api/v1/objection/all";
export const ADDOBJECTIONREQUEST = "/oas/api/v1/objection";
export const DROPDOWNOBJECTIONREQ =
  "/oas/api/v1/objectionrequest/dropdowndetails";
export const GETOBJREDBYID = "/oas/api/v1/objection";
export const UPDATEOBJREQ = "/oas/api/v1/objection";
export const GETOBJPAGINATION = "/oas/api/v1/objection";
export const MANAGEOBJREQ = "/oas/api/v1/objection/manage";
export const UPLOADIMAGEREQ = "/oas/api/v1/objection/uploadreferencedoc";
export const GETOBJECTIONQUESTIONS = "/oas/api/v1/objection/objectionquestions";
export const SBIEPAY_OBJECTION_REQUEST =
  "/oas/api/v1/objectionrequest/paynow/sbiepay/";
export const QUIKWALLET_EPAY_OBJECTION_REQUEST =
  "/oas/api/v1/objectionrequest/paynow/quickwallet/";
export const EASEBUZZEPAY_OBJECTION_REQUEST =
  "/oas/api/v1/objectionrequest/paynow/easebuzz/";
export const BILLDESK_OBJECTION_REQUEST =
  "/oas/api/v1/objectionrequest/paynow/billdesk/";
export const CSC_OBJECTION_REQUEST =
  "/oas/api/v1/objectionrequest/paynow/ccavenue/";
export const GET_PUBLICATION_TYPE_DATA = "/oas/api/v1/publicationname";
export const SET_ADDITIONAL_QUESTIONS = "/oas/api/v1/additionalquestions";
export const GET_EXAM_DISPLAY_NAME_FOR_ADMIT_CARD =
  "/oas/api/v1/admin/admitcard/examdisplaynames";
export const GET_VERIFY_CAPTCHA = "/oas/api/v1/verifycaptcha";
export const DOWNLOAD_INTERVIEW_PT_LETTER =
  "/oas/api/v1/download/interviewptletter";
export const FORCEFULLY_LOGOUT = "/oas/api/v1/logout";
export const GET_DIGILOCKER_URL = "/oas/api/v1/oauth2/1/authorize";
export const GET_DIGILOCKER_ACCESSTOKEN = '/oas/api/v1/oauth2/1/token';
export const GET_PERSONAL_DIGILOCKER_STATUS = '/oas/api/v1/digilockerVerifyData';
export const GET_DIGILOCKER_ACCESSTOKEN_LOGIN = '/oas/api/v1/oauth2/1/login/token';
export const GET_DIGILOCKER_VERIFY_DETAILS = '/oas/api/v1/oauth2/1/login/verify';
export const REVOKE_DIGILOCKER_ACCESSTOKEN = "/oas/api/v1/oauth2/1/logout";
export const GRIEVANCE_SAVE = "/oas/api/v1/grievance";
export const GET_GRIEVANCE_LIST = "/oas/api/v1/grievancelist";
export const GET_GRIEVANCE_DETAILS = "/oas/api/v1/grievancedetails";
export const UPDATE_GRIEVANCE_DATA = "/oas/api/v1/grievanceupdate";
export const GET_DEPARTMENTS = "/oas/api/v1/admin/departments"
export const GET_ADMIN_OTP = "/oas/api/v1/admin/otps"
export const ADMIN_LOGIN = " /oas/api/v1/authenticate_oas"


export const GET_DASHBOARD_COUNT = "/oas/api/v1/dashboardcounts"

export const GET_ADVERTISEMENT_DROPDOWN = "/oas/api/v1/advertisementlist";
export const VERIFY_QUALIFICATION_DIGILOCKER = "/oauth2/1/verifyQualification";
export const INTERNSHIP = "/oas/api/v1/internship"
export const INTERNSHIP_INFORMATION = "/oas/api/v1/internship";
export const LIVE_PHOTO_DRAFT_API = "/oas/api/v1/profilelivephotodraft"


// Admin

// export const SECURITY_QUESTIONS = '/oas/api/v1/securityquestion';
// export const REGISTRATION = '/oas/api/v1/register';
// export const LOGIN = '/oas/api/v1/authenticate_oas';
// export const OTPS = '/oas/api/v1/otps';
export const DEPARTMENTS = '/oas/api/v1/admin/departments';
// export const VERIFYOTP = "/oas/api/v1/verifyotps";
export const ADMINOTPS = "/oas/api/v1/adminotps";
// export const LOGOUT = "/oas/api/v1/admin/logout";
export const GETACTIVEUSER = "/oas/api/v1/admin/alloasusers";
// export const SESSION_HEARTBEAT = "/oas/api/v1/admin/sessionheartbeat";
export const GETROLES = "/oas/api/v1/admin/roles";
export const GETSUPERVISOR = "/oas/api/v1/admin/roles";
export const ADDUSER = "/oas/api/v1/admin/adduser";
export const ADDADMINUSER = "/oas/api/v1/admin/useroasapproval"
export const UPDATEUSERREQUEST = "/oas/api/v1/admin/entityapproval?isExpQual=false&level=1";
export const DELETEUSERREQUEST = "/oas/api/v1/admin/canceluserapproval";
export const GETAPPROVALUSER = "/oas/api/v1/admin/useroasapproval";
export const APPROVALUSER = "/oas/api/v1/admin/approvaluser"
export const VERIFY_USER = "/oas/api/v1/admin/verifyuser";
export const UPDATE_VERIFY_USER = "/oas/api/v1/admin/updatemobileemailverify";
export const VERIFICATIONOTP_FOR_USERVERIFY = "/oas/api/v1/verifyotpsforverifieduser";
// export const API_REPO_VERSION = "/oas/api/v1/version";
//export const LOGIN= '/oas/api/v1/authenticate';
// export const FORGETPASSWORD = "/oas/api/v1/admin/forgotpassword";
// export const RESETPASSWORD = "/oas/api/v1/admin/resetpassword";
// export const CHANGE_PASSWORD = "/oas/api/v1/admin/changepassword";
// export const RESET_PASSWORD = " /oas/api/v1/admin/resetpasswordforfirsttimelogin";
export const CHECK_USER = "/oas/api/v1/admin/isvaliddepartment";
export const GETADVERTISEMENT = "/oas/api/v1/admin/alladvertisements";
export const GETPASTADVERTISEMENT = "/oas/api/v1/admin/allpastadvertisements";
export const GETCHALLANDETAILS = "/oas/api/v1/admin/advertisements/";
export const GETCHALLANCANDIDATES = "/oas/api/v1/admin/advertisements/";
export const UPLOADCHALLANDETAILS = "/oas/api/v1/admin/uploadchallandetails";
export const SENDCHALLANDETAILSTOBANK = "/oas/api/v1/admin/sendchallandetailstobank";
export const CANDIDATEDOCUMENTDETAILS = "/oas/api/v1/admin/candidatedocumentdetails/";
export const UPDATEDOCUMNENTSINFO = "/oas/api/v1/updatedocumnentsinfo/";
// export const DOWNLOAD_DOCUMENT = "/oas/api/v1/admin/downloadrequireddocuments";
export const OASUSERS = "/oas/api/v1/admin/oasusers/";
export const ADDDOCFORAPPROVAL = "/oas/api/v1/admin/adddocforapproval";
export const DOCAPPROVAL = "/oas/api/v1/admin/docapproval/";
export const DOCUMENTAPPROVAL = "/oas/api/v1/admin/docapproval";
export const GETAPPLICATIONDETAILS_BY_ADVERTISEMENT = "/oas/api/v1/admin/getapplicationdetailsbyadvertisement/"
export const ADVERTISEMENT_DETAILS = "/oas/api/v1/admin/getadvertisementsdetails";
export const CANDIDATE_DOC_DOWNLOAD = "/oas/api/v1/candidateDocument";
export const PAST_ADVERTISEMENT_DETAILS = "/oas/api/v1/admin/allpastadvertisements";
export const ADVERTISEMENT_DOC_DOWNLOAD = "/oas/api/v1/downloadalldocuments";
export const APPROVALACTIONSHISTORY = "/oas/api/v1/admin/docapprovalactions/";
export const ALLACTIVEADVERTISEMENT = "/oas/api/v1/admin/allactiveadvertisements";
export const ALLPASTADVERTISEMENT = "/oas/api/v1/admin/allpastadvertisements";
export const DOWNLOADBANKFILE = "/oas/api/v1/admin/downloadbankfile";
export const SEARCHCANDIDATE = "/oas/api/v1/admin/searchcandidate";
// export const LOOKUP_OPTION = '/oas/api/v1/lookupoption';
// export const ADVERTISEMENT = "/oas/api/v1/advertisements";
// export const CHECK_ELIGIBILITY = "/oas/api/v1/checkeligibility";
// export const MERGED_PROFILE_INFO_DISPLAY = "/oas/api/v1/profilecreationmergeddraft";
// export const PROFILE_INFO_DISPLAY = "/oas/api/v1/profilecreationdraft";
// export const STATES = '/oas/api/v1/state';
// export const QUALIFICATION_TYPES = '/oas/api/v1/qualificationtype';
// export const RECHECK_ELIGIBILITY = "/oas/api/v1/recheckeligibility/";
export const UPLOADMARKSHEET = "/oas/api/v1/admin/uploadmarksheet";
export const MARKSHEETTEMPLATE = "/oas/api/v1/admin/marksheettemplate";

export const GETDOCUMENTTYPELIST = "/oas/api/v1/admin/getalldocumenttypes";
export const GETDOCUMENTTYPE = "/oas/api/v1/admin/getdocumenttype";
export const ADDDOCUMENTYPE = "/oas/api/v1/admin/createdocumenttype";
export const EDITDOCUMENTYPE = "/oas/api/v1/admin/updatedocumenttype";
export const SEARCHDOCUMENTYPE = "/oas/api/v1/admin/searchdocumenttype";
export const MANAGEDOCUMENTYPE = "/oas/api/v1/admin/managedocumenttype";

export const GET_ALL_STAGES_LIST = "/oas/api/v1/admin/stages";

export const GET_ALL_STAGES_CONFIG_BY_ADV_ID = "/oas/api/v1/admin/advertisement/advertisementstage";
export const ADD_UPDATE_STAGE_CONFIG = "/oas/api/v1/admin/advertisementstage";
export const GET_STAGE_CONFIG_BY_ID = "/oas/api/v1/admin/advertisementstage";
export const MANAGE_STAGE_CONFIG = "/oas/api/v1/admin/advertisementstage/manage";
export const ASSIGNTONEXTAPPROVER = "/oas/api/v1/admin/docapprovalactions/assigntonextapprover";
export const SENDLISTTORESULTSECTION = "/oas/api/v1/admin/publishdocument";
export const GET_ALL_SUBJECTS_BY_PCT_ID = "/oas/api/v1/admin/postcriteria/subjects";
export const GET_ADVERTISEMENT_DETAILS_BY_ID = "/oas/api/v1/advertisements";
export const ADD_ADVERTISEMENT_RETOTALING = "/oas/api/v1/retotaling/config";
export const UPDATE_ADVERTISEMENT_RETOTALING = "/oas/api/v1/retotaling/config";

export const DOWNLOAD_RETOTALING_REQUEST = "/oas/api/v1/retotaling/requests/download";
export const UPLOAD_RETOTALING_RESULT_LIST = "/oas/api/v1/admin/uploadmarksheet";
export const GETQUALIFICATION_TYPES = "/oas/api/v1/admin/qualificationtype";
export const GETQUALIFICATIONTYPELIST = "/oas/api/v1/admin/qualificationtype";
export const GETQUALIFICATIONTYPE = "/oas/api/v1/admin/qualificationtype";
export const ADDQUALIFICATIONTYPE = "/oas/api/v1/admin/qualificationtype";
export const EDITQUALIFICATIONTYPE = "/oas/api/v1/admin/qualificationtype";
export const SEARCHQUALIFICATIONTYPE = "/oas/api/v1/admin/qualificationtype";
export const MANAGEQUALIFICATIONTYPE = "/oas/api/v1/admin/qualificationtype/manage";

export const GETQUALIFICATIONNAMELIST = "/oas/api/v1/admin/qualificationname";
export const GETQUALIFICATIONNAME = "/oas/api/v1/admin/qualificationname";
export const ADDQUALIFICATIONNAME = "/oas/api/v1/admin/qualificationname";
export const EDITQUALIFICATIONNAME = "/oas/api/v1/admin/qualificationname";
export const SEARCHQUALIFICATIONNAME = "/oas/api/v1/admin/qualificationname";
export const MANAGEQUALIFICATIONNAME = "/oas/api/v1/admin/qualificationname/manage";

export const GETQUALIFICATION_SUBJECTS = '/oas/api/v1/admin/subjects';
export const MANAGE_QUALIFICATION_SUBJECT = '/oas/api/v1/admin/managesubjects';
export const ADD_QUALIFICATION_SUBJECT = '/oas/api/v1/admin/createsubject';
export const EDIT_QUALIFICATION_SUBJECT = '/oas/api/v1/admin/updatesubject';
export const GET_QUALIFICATION_SUBJECT = '/oas/api/v1/admin/subjects';
export const GETQUALIFICATION_NAME = '/oas/api/v1/admin/qualificationname';
export const GETQUALIFICATION_TYPES_FOR_COMBO = "/oas/api/v1/qualificationtype";
export const GETQUALIFICATION_NAME_FOR_COMBO = "/oas/api/v1/qualificationname";

export const GET_UNIVERSITY = "/oas/api/v1/admin/university";
export const EDIT_UNIVERSITY = "/oas/api/v1/admin/university";
export const ADD_UNIVERSITY = "/oas/api/v1/admin/university";
export const UNIVERSITY_STATES = "/oas/api/v1/admin/states";
export const ADMIN_UNIVERSITY_STATES = "/oas/api/v1/admin/states/0/40";
export const MANAGE_UNIVERSITY = "/oas/api/v1/admin/university/manage";
export const GET_UNIVERSITIES = "/oas/api/v1/admin/university/search";
export const GET_All_MODULES = "/oas/api/v1/admin/lookupoption/module";
export const GET_ALL_TYPES = "/oas/api/v1/admin/lookupoption/type";
export const GET_LOOKUP_OPTIONS = "/oas/api/v1/admin/lookupoption/search";
export const MANAGE_LOOKUP_OPTION = "/oas/api/v1/admin/lookupoption/manage";
export const ADD_LOOKUP_OPTION = "/oas/api/v1/admin/lookupoption";
export const EDIT_LOOKUP_OPTION = "/oas/api/v1/admin/lookupoption";
export const GET_LOOKUP_OPTION = "/oas/api/v1/admin/lookupoption";
export const GET_ALL_PARENT_LABELS = "/oas/api/v1/admin/lookupoption/parent";
export const GET_ALL_PARENT_TYPE = "/oas/api/v1/admin/lookupoption/parent";

export const SEARCH_STATES = "/oas/api/v1/admin/state";
export const GET_ALL_STATES = "/oas/api/v1/admin/states";
export const GET_STATE_BY_ID = "/oas/api/v1/admin/state/";
export const ADD_STATE_DATA = "/oas/api/v1/admin/state/";
export const EDIT_STATE_DATA = "/oas/api/v1/admin/state/";
export const MANAGE_STATE_DATA = "/oas/api/v1/admin/state/manage";

export const GET_ALL_DISTRICT_SEARCH = "/oas/api/v1/admin/district";
export const GET_ALL_DISTRICT = "/oas/api/v1/admin/district";
export const GET_DISTRICT = "/oas/api/v1/admin/district";
export const GET_DISTRICT_STATES = "/oas/api/v1/admin/states";
export const MANAGE_DISTRICT = "/oas/api/v1/admin/district/manage";
export const ADD_DISTRICT = "/oas/api/v1/admin/district";
export const EDIT_DISTRICT = "/oas/api/v1/admin/district";

export const GET_ALL_TALUKA_SEARCH = "/oas/api/v1/admin/taluka/search";
export const GET_ALL_TALUKA = "/oas/api/v1/admin/taluka";
export const GET_TALUKA = "/oas/api/v1/admin/taluka";
export const GET_TALUKA_STATES = "/oas/api/v1/admin/states";
export const GET_TALUKA_DISTRICTS = "/oas/api/v1/admin/districts";
export const MANAGE_TALUKA = "/oas/api/v1/admin/taluka/manage";
export const ADD_TALUKA = "/oas/api/v1/admin/taluka";
export const EDIT_TALUKA = "/oas/api/v1/admin/taluka";

export const GET_ALL_VILLAGE_SEARCH = "/oas/api/v1/admin/searchvillage";
export const GET_ALL_VILLAGE_SUBDIST = "/oas/api/v1/admin/getallvillages";
export const GET_ALL_VILLAGE = "/oas/api/v1/admin/getallvillages";
export const GET_VILLAGE = "/oas/api/v1/admin/village";
export const GET_VILLAGE_STATES = "/oas/api/v1/admin/states";
export const GET_VILLAGE_DISTRICTS = "/oas/api/v1/admin/districts";
export const GET_VILLAGE_TALUKAS = "/oas/api/v1/admin/taluka/bydistrict";
export const MANAGE_VILLAGE = "/oas/api/v1/admin/managevillage";
export const ADD_VILLAGE = "/oas/api/v1/admin/village";
export const EDIT_VILLAGE = "/oas/api/v1/admin/village";

export const SEARCH_EXAM_SUBJECTS = "/oas/api/v1/admin/examsubject";
export const GET_ALL_EXAM_SUBJECTS = "/oas/api/v1/admin/examsubjects";
export const GET_EXAM_SUBJECT_BY_ID = "/oas/api/v1/admin/getexamsubject";
export const ADD_EXAM_SUBJECT_DATA = "/oas/api/v1/admin/createdexamsubject";
export const EDIT_EXAM_SUBJECT_DATA = "/oas/api/v1/admin/updateexamsubject";
export const MANAGE_EXAM_SUBJECT_DATA = "/oas/api/v1/admin/examsubject/manage";

export const GET_ALL_STAGE_SEARCH = "/oas/api/v1/admin/stages/search";
export const GET_ALL_STAGES = "/oas/api/v1/admin/stages";
export const GET_STAGE_BY_ID = "/oas/api/v1/admin/stage";
export const MANAGE_STAGE = "/oas/api/v1/admin/stages/manage";
export const ADD_STAGE = "/oas/api/v1/admin/stages";
export const EDIT_STAGE = "/oas/api/v1/admin/stages";
export const ADDVENUE = "/oas/api/v1/admin/venue";
export const GET_ALL_EXAM_CENTERS_LIST_FOR_DROPDOWN = "/oas/api/v1/admin/venue/examcenters";
export const GET_ALL_STATES_LIST_FOR_DROPDOWN = "/oas/api/v1/admin/states";
export const GET_ALL_DISTRICTS_LIST_FOR_DROPDOWN = "/oas/api/v1/admin/districts";
export const GET_ALL_SUBDISTRICTS_LIST_FOR_DROPDOWN = "/oas/api/v1/admin/taluka/bydistrict";
export const GET_ALL_VILLAGES_LIST_FOR_DROPDOWN = "/oas/api/v1/admin/villages";
export const GET_ALL_EXAM_MODES_LIST_FOR_DROPDOWN = "/oas/api/v1/admin/lookupoption/bytype";
//export const GET_ALL_COORDINATOR_ROLES_LIST_FOR_DROPDOWN = "/oas/api/v1/admin/lookupoption/bytype";
export const GET_ALL_COORDINATOR_ROLES_LIST_FOR_DROPDOWN = "/oas/api/v1/admin/venuemanagement/roles";
export const GET_ALL_COORDINATOR_GENDERS_LIST_FOR_DROPDOWN = "/oas/api/v1/admin/lookupoption/bytype";
export const GET_ALL_UNAPPROVAL_ENTITY_LIST = "/oas/api/v1/admin/entityapprovalaction/manage";
export const ENTITY_APPROVAL = "/oas/api/v1/admin/entityapproval";
export const GET_ALL_APPROVED_ENTITY_LIST = "/oas/api/v1/admin/venue";
export const ENTITY_MODIFY = "/oas/api/v1/admin/venue/manage";
export const UPLOAD_VENUE_CSV = "/oas/api/v1/admin/venue/uploadvenue";

export const GET_REPORT_DATA_LIST = "/oas/api/v1/admin/getallreportrequisitiondata";
export const FILTER_REPORT_DATA = "/oas/api/v1/admin/getfilterreportrequisitiondata";
export const GET_ADVERTISEMENT_NO_REPORT_DATA = "/oas/api/v1/admin/fetchadvertisementnumber";
export const GET_GROUP_NAMES_FOR_COMBO = "/oas/api/v1/lookupoptions";
export const GET_EXAM_TYPES_FOR_COMBO = "/oas/api/v1/lookupoptions";
export const GET_DEPARTMENT_NAMES_FOR_COMBO = "/oas/api/v1/admin/requisitiondepartments";
export const GET_DATE_RANGE = "/oas/api/v1/admin/fetchdaterange";

export const ADD_REQUISITION = "/oas/api/v1/admin/requisition";
export const GET_ALL_REQUISITION = "/oas/api/v1/admin/getallrequisition";
export const GET_ALL_REQUISITION_DROPDOWN = "/oas/api/v1/admin/requisitions";
export const GET_REQUISITION_BY_ID = "/oas/api/v1/admin/requisition";
export const FILTER_REQUISITION = "/oas/api/v1/admin/filterrequisitions";
export const UPDATE_REQUISITION = "/oas/api/v1/admin/requisition";
export const MANAGE_REQUISITION = "/oas/api/v1/admin/managerequisition";

export const GET_ALL_REQUISITION_POST_DROPDOWN = "/oas/api/v1/admin/getrequisitionpost";
export const GET_ALL_REQUISITION_DEPARTMENT_DROPDOWN = "/oas/api/v1/admin/requisitiondepartments";
export const GET_ALL_REQUISITION_SPECIALISATION_DROPDOWN = "/oas/api/v1/admin/requisitionspecialisations";
// export const GET_ALL_REQUISITION_INSTITUTION_DROPDOWN ="/oas/api/v1/admin/getrequisitioninstitution";
export const GET_ALL_REQUISITION_INSTITUTION_DROPDOWN = "/oas/api/v1/admin/requisitioninstitutions";
export const GET_ALL_REQUISITION_LOOKUP_OPTION_DROPDOWN = "/oas/api/v1/lookupoptions";


export const SEARCH_SPECIALIZATION = "/oas/api/v1/admin/searchrequisitionspecialisation";
export const GET_ALL_SPECIALIZATION = "/oas/api/v1/admin/getallrequisitionspecialisations";
export const GET_SPECIALIZATION_BY_ID = "/oas/api/v1/admin/requisitionspecialisation";
export const ADD_SPECIALIZATION_DATA = "/oas/api/v1/admin/requisitionspecialisation";
export const EDIT_SPECIALIZATION_DATA = "/oas/api/v1/admin/requisitionspecialisation";
export const MANAGE_SPECIALIZATION_DATA = "/oas/api/v1/admin/managerequisitionspecialisation";

export const SEARCH_REQUISITIONPOST = "/oas/api/v1/admin/searchrequisitionpost";
export const GET_ALL_REQUISITIONPOST = "/oas/api/v1/admin/getallrequisitionpost";
export const GET_REQUISITIONPOST_BY_ID = "/oas/api/v1/admin/requisitionpost";
export const ADD_REQUISITIONPOST_DATA = "/oas/api/v1/admin/requisitionpost";
export const EDIT_REQUISITIONPOST_DATA = "/oas/api/v1/admin/requisitionpost";
export const MANAGE_REQUISITIONPOST_DATA = "/oas/api/v1/admin/managerequisitionpost";


export const SEARCH_REQUISITION_DEPARTMENT = "/oas/api/v1/admin/searchrequisitiondepartment";
export const GET_ALL_REQUISITION_DEPARTMENTS = "/oas/api/v1/admin/getallrequisitiondepartments";
export const GET_REQUISITION_DEPARTMENTS = "/oas/api/v1/admin/requisitiondepartments";
export const GET_REQUISITION_DEPARTMENT_BY_ID = "/oas/api/v1/admin/requisitiondepartment";
export const ADD_REQUISITION_DEPARTMENT_DATA = "/oas/api/v1/admin/requisitiondepartment";
export const EDIT_REQUISITION_DEPARTMENT_DATA = "/oas/api/v1/admin/requisitiondepartment";
export const MANAGE_REQUISITION_DEPARTMENT_DATA = "/oas/api/v1/admin/managerequisitiondepartment";

//Institution 
export const SEARCH_INSTITUTION = "/oas/api/v1/admin/searchrequisitioninstitution";
export const GET_ALL_INSTITUTION = "/oas/api/v1/admin/getallrequisitioninstitution";
export const GET_INSTITUTION = "/oas/api/v1/admin/getrequisitioninstitution";
export const GET_INSTITUTION_ID = "/oas/api/v1/admin/requisitioninstitution";
export const ADD_INSTITUTION_DATA = "/oas/api/v1/admin/requisitioninstitution";
export const EDIT_INSTITUTION_DATA = "/oas/api/v1/admin/requisitioninstitution";
export const MANAGE_INSTITUTION_DATA = "/oas/api/v1/admin/managerequisitioninstitution";

export const UPDATE_ADVERTISEMENT_FEE_CONFIG = '/oas/api/v1/admin/advertisementconfig';


export const GETDEPARTMENT_NAMES_FOR_COMBO = "/oas/api/v1/admin/requisitiondepartments";
export const GETEXAM_TYPES_FOR_COMBO = "/oas/api/v1/lookupoptions";
export const GETPOST_NAMES_FOR_COMBO = "/oas/api/v1/admin/getrequisitionpost";
export const GETGROUP_NAMES_FOR_COMBO = "/oas/api/v1/lookupoptions";
export const SEARCH_ADVERTISEMENT_REPORTS = "/oas/api/v1/admin/getreportalladvertisement";
export const FILTER_ADVERTISEMENT_REPORTS = "/oas/api/v1/admin/filterreportalladvertisement";
export const GETRECRUITMENT_TYPES_FOR_COMBO = "/oas/api/v1/lookupoptions";

export const GET_ALL_DEPARTMENTWISE_SUMMARY = "/oas/api/v1/admin/getreportallsummary";
export const FILTER_DEPARTMENTWISE_SUMMARY = "/oas/api/v1/admin/filterreportallsummary";

export const GET_ALL_REPORT_DATA_LIST = "/oas/api/v1/admin/getallreportrequisitiondata";
export const GET_ALL_FILTER_REPORT_DATA = "/oas/api/v1/admin/getfilterreportrequisitiondata";
export const GET_ALL_ADVERTISEMENT_REPORT_LIST = "/oas/api/v1/admin/getreportalladvertisement";
export const GET_ALL_FILTER_ADVERTISEMENT_REPORT_LIST = "/oas/api/v1/admin/filterreportalladvertisement";
export const GET_ALL_DEPARTMENTWISE_SUMMARY_LIST = "/oas/api/v1/admin/getreportallsummary";
export const GET_ALL_FILTER_DEPARTMENTWISE_SUMMARY_LIST = "/oas/api/v1/admin/filterreportallsummary";

export const GET_APPLICATION_DETAILS_BY_ID = "/oas/api/v1/admin/applications";
export const PROFILE = "/oas/api/v1/profile";
export const CANDIDATE_PROFILE_INFO_DISPLAY = "/oas/api/v1/admin/profilecreationdraft";

export const GET_DEBARRED_BY_ID = "/oas/api/v1/admin/debarred";
export const GET_DEBARRED_PAGINATION = "/oas/api/v1/admin/searchDebarred";
export const ADD_NEW_DEBARRED = "/oas/api/v1/admin/debarred";
export const UPDATE_DEBARRED = "/oas/api/v1/admin/debarred";
export const GET_All_DEBARRED_PAGINATION = "/oas/api/v1/admin/getalldebarred";
export const GET_ALL_DEBARRED_DATA = "/oas/api/v1/admin/debarmentlist"
export const DELETE_DEBARRED_DATA = "/oas/api/v1/admin/managedebarred";
export const GET_EVIDENCE_DATA = "/oas/api/v1/admin/viewevidence";

export const GET_VENUE_LIST = "/oas/api/v1/admin/venues";
export const GET_DEBARRED_DROPDOWN = "/oas/api/v1/lookupoptions";

export const GETDASHBOARSDUSERLIST = "/oas/api/v1/admin/venuemanagement/getuserslist";
export const GETATTENDENTLISTDATA = "/oas/api/v1/admin/venuemanagement/getattendantorabsenteelist";
export const GETADVERTISEMENTANDEXAMLIST = "/oas/api/v1/admin/venuemanagement/getadvertisementandexamlist";

export const GET_ALL_UPLOADED_DOCUMENTS = "/oas/api/v1/admin/getavailablecircularlist";
export const GET_ALL_VENUES = "/oas/api/v1/admin/venues";

export const GETDOCUMENTLISTDATA = "/oas/api/v1/admin/getavailablecircularlist";
export const GETALLEXAMLISTDATA = "/oas/api/v1/admin/venuemanagement/getexamlist";
export const GETVENUEDASHBOARDCOUNT = "/oas/api/v1/admin/venuemanagement/getvenuedashboardcount";
export const UPLOADCIRCULAR = "/oas/api/v1/admin/uploadadvertisementcircular";
export const DOWNLOADCIRCULARDATA = "/oas/api/v1/admin/downloadadvertisementcircular";
export const MODIFYCIRCULAR = "/oas/api/v1/admin/updateadvertisementcircularstatus";
export const CANDIDATELISTTEMPLATE = "/oas/api/v1/reuploaddocuments/getapplicationslist";
export const UPLOAD_CANDIDATE_LIST = "/oas/api/v1/reuploaddocuments/uploadcsv";
export const GET_REUPLOAD_DOCLIST_BY_ADVTID = "/oas/api/v1/reuploaddocuments/getapplicationslist";
export const GET_REDOWNLOAD_DOCLIST_BY_ADVTID = "/oas/api/v1/reuploaddocuments/getapplicationslist";
export const MANAGECIRCULAR = "/oas/api/v1/admin/managevertisementcircular";

export const GET_ALL_COLLECTOR_VENUES = "/oas/api/v1/admin/collector/getcollectorvenues";
export const GET_ADVERTISEMENT_DETAILS_BY_VENUE = "/oas/api/v1/admin/collector/getadvertisementandexamlist";
export const GET_USERLIST_PAGINATION_VENUE = "/oas/api/v1/admin/collector/getuserslist";
export const GET_ATTENDANCE_PAGINATION_VENUE = "/oas/api/v1/admin/collector/getattendantorabsenteelist";
export const GET_EXAMLIST_PAGINATION_VENUE = "/oas/api/v1/admin/collector/getexamlist";
export const GET_VENUECOLLECTOR_COUNT = "/oas/api/v1/admin/collector/getvenuecollectorcount";
export const GET_USER_DASHBOARD_COUNT = "/oas/api/v1/dashboardcounts";
export const SEND_REUPLOAD_DOCUMENT_TO_CANDIDATE = "/oas/api/v1/admin/sendreuploaddocumenttocandidate";
export const GET_POST_NAMES = "/oas/api/v1/admin/getpostcriteriabyadvertisementid";
export const GET_SCRUTINY_REPORT_DETAILS = "/oas/api/v1/admin/getscrutinyreport";
export const GET_EXPERIENCE_AND_QUALIFICATION_APPROVALS = "/oas/api/v1/admin/expandqualiapprovals/";
export const SENDTORESULTSECTION = "/oas/api/v1/admin/sendtoresultsection";
export const GET_ALL_EXAM_CENTERS_LIST_BY_ADVT_ID = "/oas/api/v1/admin/venueadvertisementassign/examcenter/";
export const GET_ALL_VENUES_BY_EXAM_CENTER_ID = "/oas/api/v1/admin/venueadvertisementassign/venue/";
export const ADD_ASSIGN_ADVT_TO_VENUE = "/oas/api/v1/admin/venueadvertisementassign/add";
export const GET_VENUE_DETAILS_BY_VENUE_ID = "/oas/api/v1/admin/venueadvertisementassign/getvenue/";
export const GET_ALL_ACTIVE_VENUE_ADVT = "/oas/api/v1/admin/venueadvertisementassign";
export const UPDATE_VENUE_ADVT_DETAILS = "/oas/api/v1/admin/venueadvertisementassign/update";
export const UPDATE_VENUE_ADVT_ACTIVE_DELETE_LIST_ITEM = "/oas/api/v1/admin/venueadvertisementassign/edit";
export const UPLOAD_TIMETABLE_CSV = "/oas/api/v1/admin/uploadcsv";
export const GET_TIMETABLE_CSV_LIST = "/oas/api/v1/admin/timetable/";
export const GET_ACTIVE_EXAM_LIST = "/oas/api/v1/admin/examlist";
export const GET_TIME_TABLE_DETAILS_BY_EXAM_ID = "/oas/api/v1/admin/timetableexams";
export const GET_LANGUAGE_DATAILS = "/oas/api/v1/admin/timetableexamsubject";
export const ADD_EXAM_TIME_TABLE = "/oas/api/v1/admin/timetableexams";
export const DELETE_TIME_TABLE_DETAIL = "/oas/api/v1/admin/timetableexams/manage";
export const DOWNLOAD_UPLOADED_TIME_TABLE_ERROR_FILE = "/oas/api/v1/admin/timetable/downloaderrorfile";
export const GET_EXAM_PAPER_SET_OR_EXAM_PAPER_QUESTIONS_LIMIT = "/oas/api/v1/lookupoptions";
export const ADD_OBJECTION = "/oas/api/v1/admin/advertisementstage/objection";
export const MANAGE_OBJECTION_STAGE = "/oas/api/v1/admin/advertisementstage/objection/manage";
export const GET_EXAM_SUBJECT_FOR_OBJECTION = "/oas/api/v1/admin/advertisementexamsetquestions/examsubjectlist";
export const UPLOAD_OBJECTION_FILE = "/oas/api/v1/admin/advertisementexamsetquestions/uploadcsv";
export const GET_OBJECTION_ANSWER_KEY_DATA = "/oas/api/v1/admin/advertisementexamsetquestions/all";
export const DOWNLOAD_OBJECTION_ANSWER_KEY_DATA_CSV_FILE = "/oas/api/v1/admin/advertisementexamsetquestions/downloadcsv";
export const MANAGE_OBJECTION_ANSWER_KEY_DATA = "/oas/api/v1/admin/advertisementexamsetquestions/manage";
export const GET_EXAM_SUBJECT_FOR_OBJECTION_FILE = "/oas/api/v1/admin/advertisementstage/examsubjects";
export const GET_OBJECTION_QUESTIONS = "/oas/api/v1/admin/advertisementstage/objectionquestions";
export const ADD_OBJECTION_FILE = "/oas/api/v1/admin/objectionfiles";
export const GET_ALL_OBJECTION_FILE = "/oas/api/v1/admin/objectionfiles";
export const MANAGE_OBJECTION_FILE = "/oas/api/v1/admin/objectionfiles/manage";
export const GET_OBJECTION_FILE_IMAGE = "/oas/api/v1/admin/objectionfiles";
export const GET_OBJECTION_REPORT = "/oas/api/v1/objection/all";
export const GET_OBJECTION_COUNT_REPORT = "/oas/api/v1/admin/objection/report";
export const GET_OBJECTION_ATTACHMENT_REPORT_APPLICATIONS = "/oas/api/v1/admin/objection/applications";
export const GET_OBJECTION_ATTACHMENT_REPORT_REFERENCE_DOCUMENT = "/oas/api/v1/admin/objection/referencedocuments";
export const DOWNLOAD_APPLICATION_DATA_REPORT = "/oas/api/v1/admin/applications";
export const DOWNLOAD_PRE_DATA_FORM_REPORT = "/oas/api/v1/admin/predataform";
export const DOWNLOAD_EPMS_REPORT_DATA = "/oas/api/v1/admin/exportcsv";
export const DISABILITY_CATEGORY_DETAILS = "/oas/api/v1/admin/lookupoptions/disabilities";
export const GET_CAST_CATEGORY = "/oas/api/v1/lookupoptions";
export const SET_RESERVATION_DETAILS_I = "/oas/api/v1/admin/requisitionrequest/reservationdetails";
export const GET_REQUIRED_LANGUAGE_DROPDOWN_DATA = "/oas/api/v1/lookupoptions";
export const GET_TYPING_SHORTHAND_AND_TYPES_DROPDOWN_DATA = "/oas/api/v1/admin/typingshorthandtypes";
export const SET_SERVICE_ACCESS_RULES = "/oas/api/v1/admin/requisitionrequest/serviceaccessrules";
export const SET_AGE_CRITERIA_DETAILS = "/oas/api/v1/admin/requisitionrequest/criteria";
export const SET_OTHER_DETAILS = "/oas/api/v1/admin/requisitionrequest/otherdetails";
export const SET_REQUISITION_REQUEST_FOR_APPROVAL = "/oas/api/v1/admin/requisitionrequest/sendforapproval";
export const GET_PENDING_REQUISITION_DATA_DETAILS = "/oas/api/v1/admin/requisitionrequest";
export const GET_SENT_FOR_APPROVAL_REQUISITION_DATA_DETAILS = "/oas/api/v1/admin/requisitionrequest/sentforapproval";
export const DELETE_REQUISITION_DATA_DETAILS = "/oas/api/v1/admin/requisitionrequest/delete";
export const GET_PENDING_APPROVAL_DETAILS = "/oas/api/v1/admin/requisitionrequest/pendingapprovals";
export const VIEW_REQUISITION_DOC = "/oas/api/v1/admin/requisitiondocument";
export const GET_YEAR_LIST = "/oas/api/v1/admin/years";
export const ADMIT_CARD_TEMPLATE = "/oas/api/v1/admin/admitcardtemplate";
export const GET_EXAM_TEMPLATE_LIST_FOR_IMPORT_ADMIT_CARD_CSV = "/oas/api/v1/admin/admitcard/templates";
export const GET_EXAM_CENTER_LIST = "/oas/api/v1/admin/examcenters";
export const UPDATE_EXAM_TIME_TABLE = "/oas/api/v1/admin/timetableexams";
export const DELETE_EXAM_INSTRUCTIONS_DETAIL = "/oas/api/v1/admin/examinstructions/manage";
export const GET_EXAM_INSTRUCTIONS_DATA = "/oas/api/v1/admin/examinstructions";
export const DELETE_CENTER_WISE_ADMIT_CARD_LIST = "/oas/api/v1/admin/timetables";
export const GET_SEARCH_ADMIT_CARD_LIST = "/oas/api/v1/admin/applications";
// export const GETADMITCARD = "/oas/api/v1/admin/timetable/admitcard";
export const GET_PROFILES_SUMMARY_DATA = "/oas/api/v1/admin/profilesummary";
export const GET_PROFILE_CREATION_DRAFT_DATA = "/oas/api/v1/admin/profilecreationdraft";
export const GET_VENU_DETAILS = "/oas/api/v1/admin/timetable/venues";
export const MANAGE_ADMIT_CARD_SEARCH_LIST_DATA = "/oas/api/v1/admin/timetable";
export const GET_APPLICATION_COUNT = "/oas/api/v1/admin/applicationcount";
export const GET_ALL_ACTIVE_AND_PAST_ADVERTISEMENT = "/oas/api/v1/all/advertisements";
export const GET_EXAM_DISPLAY_NAME_BY_EXAM_ID = "/oas/api/v1/admin/instructions";
export const GET_SELECT_EXAM_LISTING = "/oas/api/v1/admin/timetableexams";
export const GET_DELETED_DATA = "/oas/api/v1/admin/timetableexams/manage";
export const GET_DATA_BY_EXAM_TEMPLATE = "/oas/api/v1/admin/examinstructions";
export const VENUE_SAMPLE_CSV_FILE_DOWNLOAD = "/oas/api/v1/admin/venuetemplate";
export const VENUE_ADVT_ASSIGN_APPROVE_REJECT = "/oas/api/v1/admin/venueadvertisementassign/approvereject";
export const GET_VENUE_ADVERTISEMENT_LIST = "/oas/api/v1/admin/venueadvertisements";
export const GET_EXAM_SUBJECTS_LIST = "/oas/api/v1/admin/timetableexams/examsubjects";
export const GET_VENUE_ADVERTISEMENT_ASSIGNMENT = "/oas/api/v1/admin/venueadvertisementassignments";
export const VENUE_DISPLAY_ORDER_SAMPLE_CSV_FILE_DOWNLOAD = "/oas/api/v1/admin/venueadvtassign/template";
export const UPLOAD_VENUE_DISPLAY_ORDER = "/oas/api/v1/admin/venueadvtassign/setorder";
export const GET_APPLICATION_LISTING_API = "/oas/api/v1/admin/timetable/applicationlist";
export const SET_SEND_NOTIFICATION = "/oas/api/v1/candidate/sendnotification";
export const GET_NON_ASSIGNED_VENUE_ADVERTISEMENT_LIST = "/oas/api/v1/admin/venueadvertisements/nonassigned";
export const SET_FORM_2_DATA = "/oas/api/v1/admin/venueremuneration";
export const GET_FORM_2_DATA_STATUS = "/oas/api/v1/admin/venueremunerationstatus";
export const UPLOAD_FORM_2_CSV_FILE = "/oas/api/v1/admin/venueremuneration/upload";
export const GET_ALREADY_EXIST_FORM_2_CSV_DATA = "/oas/api/v1/admin/venueremunerationcsv";
export const SET_VENUE_ORDER = "/oas/api/v1/admin/venueadvtassign/examcenter/setvenueorder";
export const GET_APPROVED_VENU_DETAILS_FOR_ADMIT_CARDS_NOTIFICATION_SECTION = "/oas/api/v1/admin/venueadvtassign/approved";
export const UPLOAD_EXAM_STAFF_DATA = "/oas/api/v1/admin/timetable/venuestaffinfo";
export const DOWNLOAD_EXAM_STAFF_SAMPLE_FILE = "/oas/api/v1/admin/timetable/venuestaffinfo/samplefile";
export const GET_VENUE_STAFF_INFO = "/oas/api/v1/admin/timetable/venuestaffinfo/downloadfile";
export const DOWNLOAD_INTERVIEW_PT_LETTER_SAMPLE_FILE = "/oas/api/v1/admin/interviewletterpt/samplefile";
export const UPLOAD_INTERVIEW_PT_LETTER_CSV_FILE = "/oas/api/v1/admin/interviewletterpt/uploadfile";
export const DOWNLOAD_UPLOADED_INTERVIEW_PT_LETTER_FILE = "/oas/api/v1/admin/interviewletterpt/downloadfile";
export const GET_INTERVIEW_PT_LETTER_DROPDOWN_VALUES = "/oas/api/v1/admin/interviewletterpt/dropdownvalues";
export const GET_ALL_ADVERTISEMENT = "/oas/api/v1/all/advertisements";
export const GET_APPLICATION_DETAILS_FOR_CANDIDATE_MANAGEMENT = "/oas/api/v1/admin/application";
export const GET_LOOKUP_OPTIONS_DATA = '/oas/api/v1/lookupoptions';
export const GET_ALL_ADVT_LIST = "/oas/api/v1/admin/all/advertisements";
export const INTERVIEW_SCHEDULE_API_ENDPOINT = "/oas/api/v1/admin/interviewschedule";
export const GET_ELIGIBLE_CANDIDATES_SAMPLE_FILE = "/oas/api/v1/admin/eligiblecandidates/samplefile";
export const UPLOAD_ELIGIBLE_CANDIDATES_FILE = "/oas/api/v1/admin/eligiblecandidates/uploadfile";
export const DOWNLOAD_ELIGIBLE_CANDIDATES_LIST_FILE = "/oas/api/v1/admin/interviewptreport/eligiblecandidatelist";
export const DOWNLOAD_MUSTER_REPORT = "/oas/api/v1/admin/interviewptreport/musterreport";
export const GET_APPLICATION_DETAILS_FOR_APPLICATION_PROFILE_REPORT = "/oas/api/v1/admin/interviewptreport/profiledetails";
export const APPLICATION_PDF_GENERATE_API = "/oas/api/v1/pdfgenerate"
export const GET_ADMIN_GRIEVANCE_LIST = "/oas/api/v1/admin/grievancelist";
export const GET_ADMIN_GRIEVANCE_LIST_SEARCH_API = "/oas/api/v1/admin/search";
export const GET_ADMIN_GRIEVANCE_SINGLE_LIST = "/oas/api/v1/admin/grievance";
export const SET_INTERVIEW_INSTRUCTIONS_ENDPOINTS = "/oas/api/v1/admin/examinstructions";
export const GET_CANDIDATE_LIST_FOR_INTERVIEW_PT_LETTER = "/oas/api/v1/admin/candidatelist";
export const APPLICATION_VERSION_API = "/oas/api/v1/version";
export const GET_SINGLE_ADVT_DETAILS_API = "/oas/api/v1/admin/dashboard";
export const ADMIN_CHANGE_PASSWORD = "/oas/api/v1/admin/changepassword";
export const GET_SLIDE_SHOW_ACTIVE_ADVT_API = "/oas/api/v1/admin/all/activeAdvertisements";

export const CANDIDATE_PROFILE_UNLOCK = "/oas/api/v1/admin/unlockprofile";
export const GET_OTR_DETAILS = '/oas/api/v1/otrNumber';
export const CANDIDATE_REPORT = "/oas/api/v1/admin/advertisementApplicationData";
export const GET_SUPERVISOR_ROLE_API = "/oas/api/v1/admin/supervisors";
export const UPDATE_USER_MANAGEMENT_API = "/oas/api/v1/admin/entityapproval/manage";
export const GET_SINGLE_APPROVAL_DETAILS_API = "/oas/api/v1/admin/entityapprovalaction";
export const GET_SUPERVIOSR_NAME_BY_ID_API = "/oas/api/v1/admin/supervisors";
export const GET_NAVIGATION_SIDEBAR_API = "/oas/api/v1/admin/navigationPanel";
export const REPORT_ADVERTISEMENT_DOWNLOAD = '/oas/api/v1/admin/applications/report';
export const APPLICATION_PAYMENT_RECEIPT = '/oas/api/v1/admin/applications/paymentreceipt';
export const CANDIDATE_PAYMENT_REPORT = '/oas/api/v1/admin/candidate/paymentreport';

